import { useQuery } from "react-query";
import { useClient } from "utils/client";
import { AxiosInstance } from "axios";

export interface RiskGroupingTemplate {
  crn: string;
  id: string;
  label: string;
  description: string;
  members: string[];
}

interface RiskGroupingTemplateWrapper {
  crn: string;
  payload: {
    id: string;
    label: string;
    description: string;
    members: string[];
  };
}

const fetchRiskGroupingTemplates = async (
  client: AxiosInstance
): Promise<RiskGroupingTemplate[]> => {
  const { data } = await client.get<RiskGroupingTemplateWrapper[]>(
    "/risk-grouping-templates"
  );
  return data.map((item) => ({ ...item.payload, crn: item.crn }));
};

export const useRiskGroupingTemplates = () => {
  const client = useClient();

  const { data: templates = [], isLoading } = useQuery<RiskGroupingTemplate[]>(
    ["riskGroupingTemplates"],
    () => fetchRiskGroupingTemplates(client)
  );

  return { templates, isLoading };
};
